import { useTranslations } from '@vocab/react';
import {
  Columns,
  Column,
  Box,
  Heading,
  Stack,
  ContentBlock,
} from 'braid-design-system';

import { StaticPageLayout } from 'src/components';
import type { LayoutProps, PageTrackingProps } from 'src/shared/types';

import translations from './.vocab';
import { EnquiryForm } from './components';
import { ContactInfo } from './components/ContactInfo/ContactInfo';

const layoutProps: LayoutProps = {
  title: 'Contact Us',
  returnUrl: '/contact-us',
  enableHreflang: true,
  divider: true,
};

const trackingProps: PageTrackingProps = {
  eventName: 'contact_us_displayed',
  currentPage: 'feedback start',
  siteSection: 'candidate contact us',
};

const ContactUs = () => {
  const { t } = useTranslations(translations);

  return (
    <StaticPageLayout layoutProps={layoutProps} trackingProps={trackingProps}>
      <Box
        background="surface"
        paddingY="xlarge"
        paddingX={{ mobile: 'small', desktop: 'none' }}
      >
        <ContentBlock>
          <Stack space="xlarge">
            <Heading level="1">{t('Contact us')}</Heading>
            <Columns
              space={{ mobile: 'xxlarge', desktop: 'large' }}
              collapseBelow="desktop"
            >
              <Column width="3/5">
                <EnquiryForm />
              </Column>
              <Column>
                <ContactInfo />
              </Column>
            </Columns>
          </Stack>
        </ContentBlock>
      </Box>
    </StaticPageLayout>
  );
};

export default ContactUs;
